import React, { useEffect } from 'react';
import useToolStore, { TOOL_TYPES } from '../../../store/useToolStore';
import { generateCode } from '../../../utils/codeGenerators';
import GradientPreview from './GradientPreview';
import GradientControls from './GradientControls';

const GradientGenerator = () => {
  const config = useToolStore((state) => state.toolConfigs[TOOL_TYPES.GRADIENT]);
  const updateConfig = useToolStore((state) => state.updateToolConfig);
  const setGeneratedCode = useToolStore((state) => state.setGeneratedCode);

  useEffect(() => {
    const code = generateCode(TOOL_TYPES.GRADIENT, config);
    setGeneratedCode(code);
  }, [config, setGeneratedCode]);

  const handleConfigChange = (newConfig) => {
    updateConfig(TOOL_TYPES.GRADIENT, newConfig);
  };

  return (
    <div className="p-6">
      <h2 className="text-xl font-bold mb-4 text-gray-900 dark:text-white">Gradient Generator</h2>
      <GradientControls config={config} onChange={handleConfigChange} />
    </div>
  );
};

export const GradientPreviewComponent = () => {
  const config = useToolStore((state) => state.toolConfigs[TOOL_TYPES.GRADIENT]);
  return <GradientPreview config={config} />;
};

export default GradientGenerator;

